<template>
    <div>
        <v-date-picker v-model="selected"
                       :locale="$i18n.locale === 'tr' ? 'tr' : 'en-GB'"
                       :mode="isTime?'dateTime':''"
                       @input="handleInput"
                       :disabled="disabled"
                       :is24hr="isTime"
                       :masks="masks"
                       :model-config="modelConfig"
                       :min-date="computedMinDate"
                       :max-date="computedMaxDate"
                       is-expanded>
            <template v-slot="{ inputValue, inputEvents }">
                <b-input-group :class="validationError ? 'date-validation-error' : ''">
                    <input class="form-control"
                           :readonly="readonly"
                           :disabled="disabled"
                           :value="inputValue"
                            v-on="!disabled?inputEvents:{}"
                           :placeholder="setFormatShow()"
                           @input="handleFormattedInput"
                    />

                    <b-input-group-append>
                        <b-button variant="outline-secondary"
                                  class="btn-40"
                                  :disabled="disabled">
                            <i class="ri-calendar-line"></i>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
                <b-form-invalid-feedback v-if="validationError" v-html="validationError"/>

            </template>
            <template v-slot:footer v-if="showTodayButton">
                <b-col cols="12" class="p-2 border-top d-flex justify-content-end">
                    <b-col cols="4">
                        <b-button block variant="link" size="sm" @click="selectToday">
                            {{ $t('today') }}
                        </b-button>
                    </b-col>

                </b-col>
            </template>
        </v-date-picker>

    </div>
</template>

<script>
    import moment from "moment";
    export default {
        props: {
            disabled:{
              type:Boolean,
              default:false
            },
            value: {
                default: null
            },
            validationError: {
                default: false
            },
            isTime: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: true
            },
            showTodayButton:{
                type: Boolean,
                default: false
            },
            restrictDays:{
                type: Number,
                default:null
            }
        },
        computed: {
            masks() {
                if (this.isTime) {
                    return { input: 'DD/MM/YYYY HH:mm' };
                }
                return { input: 'DD/MM/YYYY' };
            },
            modelConfig() {
                return {
                    type: 'string',
                    mask: this.isTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'
                };
            },
            computedMinDate(){
                return this.restrictDays ? moment().startOf('day').toDate() : null
            },
            computedMaxDate(){
                return this.restrictDays ? moment().add(this.restrictDays, 'days').endOf('day').toDate() : null
            }
        },
        watch: {
            value: function(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.selected = newValue
                }
            }
        },
        data() {
            return {
                selected: null
            }
        },
        methods: {
            setFormatShow() {
                return this.isTime ? 'dd.mm.yyyy --:--' : 'dd.mm.yyyy'
            },
            selectToday() {
                const format = this.isTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
                const now = moment().format(format);
                this.selected = now;
                this.$emit("input", now);
            },
            handleInput(event){
                let value = null;
                if(event){
                    if(this.isTime){
                        value = moment(event).format("YYYY-MM-DD HH:mm:ss")
                    }
                    else{
                        value = moment(event).format("YYYY-MM-DD")
                    }
                }
                this.$emit("input", value)
            },
            handleFormattedInput(event) {
                if (this.readonly) return;

                let raw = event.target.value.replace(/\D/g, '');
                let formatted = '';

                if (raw.length <= 2) {
                    formatted = raw;
                } else if (raw.length <= 4) {
                    formatted = raw.slice(0, 2) + '.' + raw.slice(2);
                } else if (raw.length <= 8) {
                    formatted = raw.slice(0, 2) + '.' + raw.slice(2, 4) + '.' + raw.slice(4);
                } else {
                    formatted = raw.slice(0, 2) + '.' + raw.slice(2, 4) + '.' + raw.slice(4, 8);
                }

                event.target.value = formatted;

                const nativeInputEvent = new Event('input', { bubbles: true });
                event.target.dispatchEvent(nativeInputEvent);

                if (raw.length === 8) {
                    const parsed = moment(formatted, "DD.MM.YYYY", true);
                    if (parsed.isValid()) {
                        const iso = parsed.format("YYYY-MM-DD");
                        this.selected = iso;
                        this.$emit("input", iso);
                    } else {
                        this.selected = null;
                        this.$emit("input", null);
                    }
                } else {
                    this.selected = this.value;
                }
            }
        },
        created() {
            this.selected = this.value
        }
    }
</script>
<style scoped>
    .date-validation-error {
        border: 1px solid #ff9eae;
        border-radius: 0.375rem;
    }
</style>
